import { DashboardHomeView } from "@features/home-dashboard/components/DashboardHomeView";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/")({
  staticData: {
    title: "Accueil",
    section: "Général",
    order: 10,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: DashboardHomeRoute,
});

function DashboardHomeRoute() {
  return <DashboardHomeView />;
}
